import { Center, Divider, Heading, Text, Flex } from '@chakra-ui/react';
import { Socials } from '@components';

export function BlogHeader(): JSX.Element {
  return (
    <Center py={'24px'}>
      <Flex
        w="100%"
        h={{ base: 'auto', md: '28px' }}
        mb={{ base: '24px', md: '56px' }}
        flexDir={{ base: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ base: 'flex-start', md: 'center' }}
      >
        <Flex
          flexDir={{ base: 'column', md: 'row' }}
          alignItems={{ base: 'flex-start', md: 'center' }}
          justifyContent={{ base: 'flex-start', md: 'center' }}
          gap={6}
        >
          <Heading as="h4" size="md" color="primary.300">
            Blog
          </Heading>
          <Divider
            h="28px"
            orientation="vertical"
            display={{ base: 'none', md: 'flex' }}
          />
          <Text color="white" fontSize="16px">
            The official source for news, thoughts, and announcements from Clerk
          </Text>

          <Divider w="100%" display={{ base: 'flex', md: 'none' }} />
          <Socials />
        </Flex>
      </Flex>
    </Center>
  );
}
